export const ACCESS_TOKEN = "token";
export const ROL_USER = "rol"
export const DATE_INIT = "date_init"
export const DATE_END = "date_end"
export const USER_ID = "user_id"
export const USER_NAME = "user_name"
export const EMAIL = "usernameOrEmail"



